import { render, staticRenderFns } from "./OrderStatusesHistoryDialog.vue?vue&type=template&id=507148fd"
import script from "./OrderStatusesHistoryDialog.vue?vue&type=script&lang=js"
export * from "./OrderStatusesHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports